export const FEDERATION_CAPABILITIES = {
  workspace: "federation.workspace",
  rulesets: "federation.rulesets",
  assignments: "federation.assignments",
  audit: "federation.audit",
  approvals: "federation.approvals",
  organisations: "federation.organisations",
  finance: "federation.finance",
  players: "federation.players",
  affiliations: "federation.affiliations",
} as const;

export type FederationCapability =
  (typeof FEDERATION_CAPABILITIES)[keyof typeof FEDERATION_CAPABILITIES];

type FederationContextBase = {
  workspace_provider_id: number;
  sport: string | null;
  supported_sports: string[];
  capabilities: FederationCapability[];
};

export type StandardFederationContext = FederationContextBase & {
  context_type: "standard";
  federation_provider_id: null;
};

export type ActiveFederationContext = FederationContextBase & {
  context_type: "federation";
  federation_provider_id: number;
};

export type FederationContextResponse =
  | StandardFederationContext
  | ActiveFederationContext;

export function createStandardFederationContext(
  workspaceProviderId: number,
  sport: string | null = null,
): StandardFederationContext {
  return {
    context_type: "standard",
    workspace_provider_id: workspaceProviderId,
    federation_provider_id: null,
    sport,
    supported_sports: [],
    capabilities: [],
  };
}
